<template>
  <div id="home">
    <my-header></my-header>
    <div class="pd20">
      <ul class="breadcrumb" v-if="block">
        <li>
          <router-link :to="{ name: 'ManageTracking'}">{{'Manage tracking'|translate}}</router-link>
        </li>
        <li>
          <router-link :to="{ name: 'ManagePeriod', params: { block_id: block.id }}">{{block.name}}</router-link>
        </li>
        <li>
          <router-link
            :to="{ name: 'ManageSeason', params: { period_id: period.id }}"
          >{{period.name}}</router-link>
        </li>
        <li>{{season.name}}</li>
      </ul>

      <loading
        v-if="list_items == null ||  actions == null "
        class="mt20"
        :text="'Please wait'|translate"
      ></loading>
      <div v-if="actions">
        <ul class="nav nav-tabs" id="myTabs" role="tablist">
          <li role="presentation" v-bind:class="{ active: select_tab == 'manage_history' }">
            <a href="#" v-on:click="select_tab = 'manage_history'">{{'Histories'|translate}}</a>
          </li>
          <li role="presentation" v-bind:class="{ active: select_tab == 'manage_harvest' }">
            <a href="#" v-on:click="select_tab = 'manage_harvest'">{{'Harvest'|translate}}</a>
          </li>
        </ul>
        <div class="tab-content">
          <div
            class="tab-pane fade"
            v-bind:class="{ active: select_tab == 'manage_history', in: select_tab == 'manage_history' }"
          >
            <a class="btn btn-primary" v-on:click="showModal(null)">{{'Add history'|translate}}</a>
            <div class="pull-right">
              <!-- <input type="text" class="form-control" v-model="keyword"  v-on:keypress.enter.prevent="search()" :placeholder="'Search'|translate"  /> -->
            </div>

            <p
              class="mt10"
              v-if="list_items && list_items.length == 0"
            >{{'There is no data'|translate}}</p>
            <table class="table mt10" v-if="list_items && list_items.length > 0">
              <thead>
                <tr>
                  <th>{{'ID'|translate}}</th>
                  <th>{{'Action name'|translate}}</th>
                  <th>{{'Start date'|translate}}</th>
                  <th>{{'Done by'|translate}}</th>
                  <th>{{'Action'|translate}}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item) in list_items" :key="item.id">
                  <td>{{item.id}}</td>
                  <td>{{item.action_name}}</td>
                  <td>{{ item.start_date | moment("DD/MM/YYYY") }}</td>
                  <td>{{ item.done_by }}</td>
                  <td>
                    <a
                      class="btn btn-primary"
                      v-on:click="showDetailModal(item)"
                    >{{'Detail'|translate}}</a>
                    <a
                      class="btn btn-danger"
                      v-on:click="removeItem(item)"
                      :disabled="removing"
                    >{{'Delete'|translate}}</a>
                    <a
                      class="btn btn-info"
                      v-bind:class="{disabled:item.remain_text == 0}"
                      v-on:click="showModal(item)"
                    >
                      {{'Update'|translate}}
                      <span
                        v-if="item.remain_text != 0"
                      >[{{item.remain_text}}]</span>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
            <paginate
              v-if="total_page > 1"
              :page-count="total_page"
              :click-handler="clickPage"
              :prev-text="'Prev'|translate"
              :next-text="'Next'|translate"
              v-model="page"
              :container-class="'pagination'"
            ></paginate>
            <form-history
              v-if="show_form"
              ref="manage_form"
              :season_id="season_id"
              :actions="actions"
              :pass_data="pass_data"
              @modalData="modalData"
            ></form-history>
            <history-detail
              v-if="show_detail_form"
              ref="manage_detail_form"
              :pass_data="pass_detail_data"
            ></history-detail>
          </div>
          <div
            class="tab-pane fade"
            v-bind:class="{ active: select_tab == 'manage_harvest', in: select_tab == 'manage_harvest' }"
          >
            <manage-harvest :season_id="season_id" :harvest_id="harvest_id"></manage-harvest>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Utils from "@/helpers/utils";
import MyHeader from "@/components/Layout/Header";
import FormHistory from "@/components/Cultivation/FormHistory";
import HistoryDetail from "@/components/Cultivation/HistoryDetail";
import ManageHarvest from "@/components/Cultivation/ManageHarvest";
import Paginate from "vuejs-paginate";
import Loading from "@/components/elements/Loading";
export default {
  name: "History",
  components: {
    MyHeader,
    FormHistory,
    Paginate,
    ManageHarvest,
    HistoryDetail,
    Loading
  },
  data() {
    return {
      show_form: false,
      show_detail_form: false,
      pass_data: null,
      pass_detail_data: null,
      list_items: null,
      removing: false,
      page: 1,
      offset: 0,
      keyword: "",
      limit: Utils.getLimit(),
      total_page: 1,
      block_id: null,
      season_id: null,
      harvest_id: null,
      period: null,
      block: null,
      actions: null,
      select_tab: "manage_history"
    };
  },
  methods: {
    modalData(data) {
      console.log("modalData", data);
      if (data) {
        for (let i = 0; i < this.list_items.length; i++) {
          if (this.list_items[i].id == data.id) {
            for (let key in data) {
              this.list_items[i][key] = data[key];
            }
            console.log("found");
          }
        }
      } else {
        this.list();
      }
    },
    showModal(data) {
      this.show_form = true;
      this.pass_data = data != null ? JSON.parse(JSON.stringify(data)) : data;

      setTimeout(() => {
        this.$refs.manage_form.open();
      });
    },
    showDetailModal(data) {
      this.pass_detail_data =
        data != null ? JSON.parse(JSON.stringify(data)) : data;
      this.show_detail_form = true;
      setTimeout(() => {
        this.$refs.manage_detail_form.open();
      });
    },
    list() {
      let data = {
        offset: this.offset,
        limit: this.limit,
        keyword: this.keyword,
        season_id: this.season_id
      };
      console.log("data", data);
      Utils.request(this, true, "land")
        .get(`/manageHistory/?${Utils.arrayToRequestParam(data)}`)
        .then(response => {
          let data = response.data;
          if (data.status === "ok") {
            console.log("data.data", data.data);
            let list = data.data.list;
            list = list.map(item => {
              let temp = new Date(parseInt(item.add_time) * 1000);
              item.add_date = this.$moment(temp);

              let temp1 = new Date(parseInt(item.start_time) * 1000);
              item.start_date = this.$moment(temp1);
              item.remain_text = Utils.getFormattedTime(this, item.add_date);
              return item;
            });
            this.list_items = list;
            console.log("data.data.total", data.data.count);
            this.total_page = Utils.getTotalPages(data.data.count);
            console.log("this.total_page", this.total_page);
            // update local storage
          }
        })
        .catch(error => {
          this.updating = false;
          Utils.showErrorMessage(this, error.response);
        });
    },
    getSeason() {
      let waiting = [
        Utils.request(this, true, "land").get(`/manageSeason/${this.season_id}`)
      ];

      waiting.push(Utils.request(this, true, "land").get(`/manageAction/`));

      Promise.all(waiting)
        .then(values => {
          this.season = values[0].data.data.data;
          this.period = values[0].data.data.period;
          this.block = values[0].data.data.block;
          // console.log("this.block", values[0]);
          this.actions = values[1].data.data;

          Utils.request(this, true, "land")
            .get(`/manageBlock/${this.period.block_id}`)
            .then(response => {
              this.block = response.data.data;
            });
        })
        .catch(error => {
          Utils.showErrorMessage(this, error.response);
        });
    },
    removeItem(item) {
      this.$alertify.confirmWithTitle(
        this.$t("Confirm"),
        this.$t("Are you sure to remove this item ?"),
        () => {
          this.removing = true;
          Utils.request(this, true, "land")
            .delete(`/manageHistory/${item.id}`)
            .then(response => {
              this.removing = false;
              let data = response.data;
              if (data.status === "ok") {
                this.offset = 0;
                this.list();
              }
            });
        }
      );
    },
    clickPage(pageNum) {
      console.log("pageNum", pageNum);
      this.offset = Utils.getNextOffset(pageNum);
      this.list();
    },
    search() {
      console.log("keyword", this.keyword);
      this.offset = 0;
      this.list();
    }
  },
  mounted() {
    this.season_id = this.$route.params.season_id;
    if (location.href.indexOf("harvest") != -1) {
      this.select_tab = "manage_harvest";
      this.harvest_id = this.$route.params.harvest_id;
    }
    this.list();
    this.getSeason();
    this.$options.interval = setInterval(() => {
      Utils.updateDateTime(this);
    }, 1000);
  },
  beforeDestroy() {
    clearInterval(this.$options.interval);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Cultivation/ManageHistory.vue